/* eslint linebreak-style: ["error", "windows"] */
import React from 'react';
import { Navbar, Nav, NavDropdown } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHome, faCalendarAlt, faSignOutAlt } from '@fortawesome/free-solid-svg-icons';
import { LinkContainer } from 'react-router-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../assets/css/header.css';
import logo from '../assets/images/un-logo.svg';
import { urlbase } from '../utils/utils';
import { getusernamelogged } from '../services/login';

function Header() {
  const nombreUsuario = getusernamelogged();
  return (
  <Navbar bg="light" expand="lg">
     <Navbar.Toggle aria-controls="basic-navbar-nav" />
     <Navbar.Brand href="#home"> <img src={logo} className="logo" alt="Logo Universidad del Norte" width="100" height="35" /></Navbar.Brand>
    <Navbar.Collapse id="basic-navbar-nav">
     <Nav className="ml-auto">
      <NavDropdown title={nombreUsuario} id="basic-nav-dropdown">
       <LinkContainer to={`${urlbase}${'/inicio'}`}>
        <NavDropdown.Item><FontAwesomeIcon icon={faHome} className="iconheader" />Inicio</NavDropdown.Item>
       </LinkContainer>
       <LinkContainer to={`${urlbase}${'/mis_horarios'}`}>
        <NavDropdown.Item><FontAwesomeIcon icon={faCalendarAlt} className="iconheader" />Mis horarios</NavDropdown.Item>
        </LinkContainer>
        <NavDropdown.Divider />
        <LinkContainer to={`${urlbase}${'/logout'}`}>
         <NavDropdown.Item><FontAwesomeIcon icon={faSignOutAlt} className="iconheader" />Cerrar sesión</NavDropdown.Item>
        </LinkContainer>
      </NavDropdown>
     </Nav>
    </Navbar.Collapse>
  </Navbar>
  );
}

export default Header;
